<template lang="pug" src="./custom-home-map.pug"></template>

<script>
import { Loader } from '@googlemaps/js-api-loader'
import Icon from '@/assets/icons/map-pin.svg'

/* eslint-disable */
export default {
  props: {
    props: {
      type: Object,
      default: () => ({})
    },
    global: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    mapLoading: true,
  }),
  computed: {
    location () {
      return this.global.location[0]
    },
    phoneAria () {
      if (this.global.phone.number) {
        return this.global.phone.number.replace(/-/g, '').split('').join(' ')
      } else {
        return null
      }
    }
  },
  mounted () {
    const loadMap = new Loader ({
      apiKey: 'AIzaSyC5WmgRMCU4ofdQC9J_WBaRwM-DeTvLa0U'
    })
    loadMap.load().then(()=> {
      this.createMap()
      this.addMarker()
      this.mapLoading = false
    })
  },
  methods: {
    createMap () {
      this.$map = new google.maps.Map(this.$refs.theMap, {
        center: {
          lat: 41.0065056,
          lng: -111.9999603
        },
        zoom: 12,
        streetViewControl: false,
        fullscreenControl: false,
        disableDefaultUI: true,
        zoomControl: true
        // mapId: '876c2d412dd92ae2'
      })
    },
    addMarker () {
      const $marker = new google.maps.Marker({
        position: {
          lat: 41.0335056,
          lng: -111.9799603
        },
        map: this.$map,
        icon: {
          url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(Icon),
          scaledSize: new google.maps.Size(32, 32)
        }
      })
      const $markerTwo = new google.maps.Marker({
        position: {
          lat: 40.9780712,
          lng: -111.8935614
        },
        map: this.$map,
        icon: {
          url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(Icon),
          scaledSize: new google.maps.Size(32, 32)
        }
      })
    }
  }
  // async mounted () {
  //   this.createMap()
  // },
  // methods: {
  //   createMap () {
  //   /* eslint-disable */
  //     var platform = new H.service.Platform({
  //       'app_id': 'YJhhqdT1KiOHrZ3wvqCL',
  //       'app_code': '5_Rbo3PaGUf9UO2IrgA61A',
  //       'h': '300',
  //       'useHTTPS': 'true'
  //     });

  //     // Obtain the default map types from the platform object:
  //     var defaultLayers = platform.createDefaultLayers()

  //     // instantiates map
  //     this.$map = new H.Map(
  //       this.$refs.map,
  //       defaultLayers.normal.map,
  //       {
  //         zoom: 12,
  //         center: { lat: 41.0076983, lng: -111.9410607 }
  //       }
  //     )
  //     var mapEvents = new H.mapevents.MapEvents(this.$map)
  //     var behavior = new H.mapevents.Behavior(mapEvents)

  //     // Add Marker
  //     var icon = new H.map.Icon('/static/MapMarker.svg')
  //     var coordsOne = { lat: 41.0334731, lng: -111.9392756 }
  //     var markerOne = new H.map.Marker(coordsOne, { icon: icon })
  //     var coordsTwo = { lat: 40.9779592, lng: -111.8914157 }
  //     var markerTwo = new H.map.Marker(coordsTwo, { icon: icon })

  //     this.$map.addObject(markerOne)
  //     this.$map.addObject(markerTwo)

  //     // Remove Copyright
  //     setTimeout(() => {
  //       var mapCanvas = document.getElementsByClassName('custom-home-map__map')[0]
  //       var label = mapCanvas.children[0].children[1]
  //       label.style.display = 'none'
  //     }, 500)
  //   /* eslint-enable */
  //   }
  // }
}
</script>



// WEBPACK FOOTER //
// src/components/custom/custom-home-map/custom-home-map.vue